import { useContext } from "react";
import {ReserveContext} from "../context/ReserveProvider.context";
import type {ReserveContextType} from "../context/ReserveProvider.context";

const useReserveContext = (): ReserveContextType => {
    return useContext(ReserveContext)
}

export default useReserveContext;